<template>
  <div class="login-page">
    <app-navbar-login></app-navbar-login>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image" data-color="green">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
              <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                <card type="login">
                  <h3 slot="header" class="header text-center">Login</h3>
                  <div v-if="failedAuth">
                    <div class="alert alert-danger" role="alert">Invalid email address or password</div>
                  </div>
                  <div v-if="showEmailVerificationNotice">
                    You have not verified your email. 
                    <br />
                    <router-link :to="{name: 'Resend Verification Email'}">Click here to request the verification email</router-link>
                    <br />
                  </div>
                  <fg-input name="email"
                            type="email"
                            v-model="model.email"
                            v-validate="modelValidations.email"
                            :error="getError('email')"
                            addon-left-icon="nc-icon nc-single-02" placeholder="Email Address..."></fg-input>

                  <fg-input name="password"
                            type="password"
                            v-model="model.password"
                            v-validate="modelValidations.password"
                            :error="getError('password')"
                            addon-left-icon="nc-icon nc-key-25" placeholder="Password"></fg-input>

                  <p-button slot="footer" type="success" round 
                  block class="mb-3" 
                  :disabled="isDisabled"
                  ref="loginButton"
                  @click.prevent="validate">
                    {{ loginButtonText }}
                  </p-button>
                  <p slot="footer" style="text-align:center;">
                    New to Kobotrack? <router-link :to="{name: 'Register'}">Sign Up</router-link> 
                  <br /><router-link :to="{name: 'ForgotPassword'}">Forgot your password?</router-link></p>
                </card>
              </div>
          </div>
        </div>
        <app-footer-login></app-footer-login>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import auth from 'src/auth'

  import {Card, Checkbox, Button} from 'src/components/UIComponents';
  import AppNavbarLogin from './Layout/AppNavbarLogin'
  import AppFooterLogin from './Layout/AppFooterLogin'
  export default {
    components: {
      Card,
      AppNavbarLogin,
      AppFooterLogin,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
    data () {
      return {
        model: {
          email: '',
          password: ''
        },
        modelValidations: {
          email: {
            required: true,
            email: true
          },
          password: {
            required: true,
            min: 5
          }
        },
        failedAuth: false,
        loginButtonText: 'Login',
        showEmailVerificationNotice: false,
        isDisabled: false
      }
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.registerForm, isValid)
          if(isValid){
            this.login()
          }
        })
      },
      login () {
        this.isDisabled = true
        this.failedAuth = false
        this.showEmailVerificationNotice = false
        this.loginButtonText = 'Logging In ...'
        auth.login(this.model.email, this.model.password, this.$http, loggedIn => {
          if (!loggedIn) {
            if (auth.hasNotVerifiedEmail) {
              this.failedAuth = false
              this.showEmailVerificationNotice = true
            }else {
               this.failedAuth = true
            }
            this.model.email = ''
            this.model.password = ''
            this.loginButtonText = 'Login'
            this.isDisabled = false

            this.$nextTick(function () {
              this.$validator.reset()
            })
          } else {
            
            this.$router.push(this.$route.query.redirect || '/overview')
          }
        })
      },

      enterPressed (e) {
        if(e.key == 'Enter') {
          this.validate()
        }
      }
    },
    beforeDestroy () {
      this.closeMenu()
      window.removeEventListener('keyup', this.enterPressed)
    },

    created: function () {
      window.addEventListener('keyup', this.enterPressed)
    },

    
  }
</script>
<style>
.login-page .content .container { margin-top: 0px !important; margin-left: 0px;}
.ml-auto, .mx-auto { margin-left: 0px !important; }
.login-page #websphereCoded {margin-left: 40px !important;}
.login-page .card-login .input-group:last-child { margin-bottom: 20px !important; }
</style>
